import {
  PersistedFormGroup,
  PersistedFormArray,
  PersistedArray,
} from './persisted-form-group';
import type {
  PersistedFormGroupOptions,
  PersistedFormArrayOptions,
  PersistedArrayOptions,
} from './persisted-form-group';
import type { SchemaFormControl } from '@apexdesigner/schema-forms';
import { Role } from './role';
export { Role };
import { roleSchema } from '@schemas/business-objects/role';
import { MyUserTaskFormArray } from './my-user-task-form-group';
import { RoleAssignmentFormArray } from './role-assignment-form-group';
import { UserTaskFormArray } from './user-task-form-group';

export class RoleFormGroup extends PersistedFormGroup {
  declare controls: {
    id: SchemaFormControl;
    name: SchemaFormControl;
    displayName: SchemaFormControl;
    description: SchemaFormControl;
    roleAssignments: RoleAssignmentFormArray;
    userTasks: UserTaskFormArray;
    myUserTasks: MyUserTaskFormArray;
  };

  declare value: Partial<Role>;

  constructor(
    data?: Record<string, any> | null,
    options?: PersistedFormGroupOptions,
  ) {
    super(roleSchema, Role, data, options);
  }

  get object(): Role {
    return new Role(this.getRawValue());
  }

  protected override createControl(name: string) {
    switch (name) {
      case 'roleAssignments':
        return new RoleAssignmentFormArray();
      case 'userTasks':
        return new UserTaskFormArray();
      case 'myUserTasks':
        return new MyUserTaskFormArray();
      default:
        return undefined;
    }
  }
}

export class RoleFormArray extends PersistedFormArray {
  readonly entityName = 'Role' as const;

  constructor(options?: PersistedFormArrayOptions) {
    super(roleSchema, Role, options);
  }

  protected override createItemGroup() {
    return new RoleFormGroup();
  }

  get array(): Role[] {
    return this.controls.map((group: RoleFormGroup) => group.object);
  }
}

export class RolePersistedArray extends PersistedArray<Role> {
  readonly entityName = 'Role' as const;

  constructor(options?: PersistedArrayOptions) {
    super(Role, options);
  }
}
